import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import doc                       from '@widesk-core/decorators/doc';
import model                     from '@widesk-core/decorators/model';
import TimestampAble             from '@widesk-core/models/traits/TimestampAble';
import Blamable                  from '@/models/traits/Blamable';
import WebsiteModel              from './WebsiteModel';

// Ecrit manuellement
@model.urnResource('website_entertainment')
@doc.path('/website_entertainments/{?id}')
export default class WebsiteEntertainmentModel extends Blamable(TimestampAble(WebsiteServiceModel)) {
	declare protected _tsFilters: {
		'partial': string;
		'entertainmentUrn': Urn;
		'slugPrefix': id;
		'website': id;
		'website.showUrn': Urn;
		'search': string;
	};

	declare private _tsSorts: {
		'id': string;
		'entertainmentUrn': string;
		'createdAt': string;
		'updatedAt': string;
	};

	@doc.model(WebsiteModel) declare website: WebsiteModel;
	@doc.string declare entertainmentUrn: Urn;
	@doc.string declare label: string;
	@doc.string declare slugPrefix: string;
}
